import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { DispatchNoteBus } from "./DispatchNoteBus";
import { v_LocationDetailBus } from "./v_LocationDetailBus";

export class VehicleNotesBus extends BaseBus
{
    constructor(busObj: VehicleNotesBus = null) {
        super(busObj);
        this.insertDt = DateFunctions.getDate(this.insertDt);
        this.updateDt = DateFunctions.getDate(this.updateDt);
    }
    CID(): any {
        return this.vehicleNotesId;
    }
    setParentId(id: any) {
        this.vehicleId = id;
    }
    setId(id: any) {
        this.vehicleNotesId = id;
    }
    setFromBusobj(data: VehicleNotesBus) {
        this.initialize(data);
        this.notes = data.notes;
    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(DateFunctions.getDateNow());
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: v_LocationDetailBus = null) {
        this.vehicleNotesPersonId = personId;
   
    }
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!DateFunctions.isValidDate(this.insertDt)) {
            this.insertDt = date;
            this.insertUserId = userId;
        }
        this.updateDt = date;
        this.updateUserId = userId;
        if (!CommonFunctions.hasGuidValue(this.vehicleNotesPersonId)) {
            this.vehicleNotesPersonId = personId;
        }
    }
  vehicleNotesId: any;
  notes: string;
  personName: string;
  updateUserId: any;
  updateDt: Date;
  insertUserId: any;
  insertDt: Date;
  vehicleId: any;
    vehicleNotesPersonId: any;
  //assignedPersonId: any;
}
